import { NgStyle } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { OauthService } from '@app/core/services/oauth.service';
import { RestaurantService } from '@app/core/services/restaurant.service';
import { LayoutService } from '@app/layout/services/layout.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { filter, tap } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-header',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: true,
  imports: [NgStyle, TranslateModule],
})
export class NavbarComponent implements OnInit {
  isCollapsed = true;
  currentView: string = this.router.url;
  loggedIn = false;
  isInvoiceView = false;

  constructor(
    public $restaurant: RestaurantService,
    private $oauth: OauthService,
    private router: Router,
    private $spinner: NgxSpinnerService,
    private $layout: LayoutService
  ) {}

  ngOnInit(): void {
    this.$spinner.hide();
    this.checkIfInvoiceView(this.router.url);
    this.router.events
      .pipe(
        untilDestroyed(this),
        filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd),
        tap((event: NavigationEnd) => {
          if (event instanceof NavigationEnd) {
            this.checkIfInvoiceView(event.url);
            this.isCollapsed = this.$layout.collapsed;
          }
        })
      )
      .subscribe();

    this.$oauth.loggedIn$
      .pipe(
        tap((loggedIn: boolean) => {
          this.loggedIn = loggedIn;
        })
      )
      .subscribe();
  }

  collapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.$layout.collapsed = this.isCollapsed;
  }

  private checkIfInvoiceView(url: string): void {
    this.currentView = url;
    this.isInvoiceView = url.startsWith('/private/invoice');
  }

  get getIsLocalUrl(): boolean {
    return this.currentView.includes('local');
  }
}
